import {createEndpoint} from "../../components/customRoute/Endpoints/Endpoint/EndpointFactory";
import {changeBasicField, changeMainField} from "../../store/reducers/basicFields";
import {changeEndpointField, endpointAddNew, endpointRemove} from "../../store/reducers/endpointFields";
import {addParameter, addParameterFilled, changeParameter, removeParameter} from "../../store/reducers/parameterFields";
import {addSubField, changeSubField, getSubField, removeSubField} from "../../store/reducers/subFields";
import {changeGroupField} from "../../store/reducers/groupFields";
import {saveCustomRoute, showCurrentRoute} from "../../store/reducers/customRoute";

const INITIAL_STATE = {
	settings:            {
		namespace: '',
		routeName: '',
		enabled:   true,
		endpoints: [
			createEndpoint()
		],
	},
	requiredFields:      [
		{
			field: 'namespace',
			label: 'Namespace',
		}, {
			field: 'routeName',
			label: 'Route name',
		},
		{
			field: 'method',
			label: 'Method',
		}
	],
	requiredEmptyFields: [],
	errorMessage:        '',
	saving:              false,
	saved:               false,
	routeId:             0,
	existingMethods:     [],
	invalidRoute:        false,
	customTables: [],
  premium: false,
};

export default function reducer( state = INITIAL_STATE, action ) {
	switch (action.type) {

		case 'CHANGE_BASIC_FIELDS':
			return changeBasicField( state, action );

		case 'ENDPOINT_FIELD_CHANGE':
			return changeEndpointField( state, action );

		case 'ADD_NEW_PARAMETER':
			return addParameter( state, action );

    case 'ADD_NEW_PARAMETER_FILLED':
      return addParameterFilled( state, action );

		case 'REMOVE_PARAMETER':
			return removeParameter( state, action );

		case 'CHANGE_PARAMETER':
			return changeParameter( state, action );

		case 'ENDPOINT_ADD_SUB_FIELD':
			return addSubField( state, action );

		case 'ENDPOINT_REMOVE_SUB_FIELD':
			return removeSubField( state, action );

		case 'ENDPOINT_CHANGE_SUB_FIELD':
			return changeSubField( state, action );

		case 'GROUP_FIELD_CHANGE':
			return changeGroupField( state, action );

		case 'ENDPOINT_ADD_NEW':
			return endpointAddNew( state, action );

		case 'ENDPOINT_REMOVE':
			return endpointRemove( state, action );

		case 'SAVE_CUSTOM_ROUTE':
			return saveCustomRoute( state, action );

		case 'CHANGE_MAIN_FIELD':
			return changeMainField( state, action );

		case 'SHOW_CURRENT_ROUTE':
			return showCurrentRoute( state, action );

		case 'UPDATE_CUSTOM_TABLE':
			return {
				...state,
				customTables: action.payLoad.value
			};

		default:
			return state;
	}
}
